import type { CustomIconProps } from '../types';

const DarkPlay = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '10'}
        height={height || '12'}
        viewBox="0 0 11 12"
        fill="none"
    >
        <path
            d="M0.5 10.7983V1.20174C0.5 0.213247 1.78286 -0.351006 2.68182 0.242091L9.95455 5.04035C10.6818 5.52017 10.6818 6.47983 9.95455 6.95965L2.68182 11.7579C1.78286 12.351 0.5 11.7868 0.5 10.7983Z"
            fill="#414042"
        />
    </svg>
);

export default DarkPlay;
